import { PipelineEntity } from "@ots-frontend/ots-data";
import { useCallback } from "react";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BasePipelineSelectProps = Omit<
  BaseEntitySelectProps<PipelineEntity>,
  'nameMapper'
>;

export const BasePipelineSelect = (props: BasePipelineSelectProps) => {
  const nameMapper = useCallback((e: PipelineEntity) => {
    return e.name;
  }, []);

  return <BaseEntitySelect nameMapper={nameMapper} {...props} />;
};
